
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Modal from '@/components/Modal.vue'
import { IRecipient } from '@/entities/notices'
import 'driver.js/dist/driver.min.css'
import RecipientPicker from '@/components/Notices/RecipientPicker.vue'
import DesktopRecipientPicker from './DesktopRecipientPicker.vue'

@Component<RecipientPickerModal>({
    components: {
        DesktopRecipientPicker,
        Modal,
        RecipientPicker,
    },
})
export default class RecipientPickerModal extends Vue {
    @Prop(Boolean) public show!: boolean
    @Prop(Boolean) public single!: boolean // only allow single selection
    @Prop({ type: Boolean, default: true }) public allowEmpty!: boolean // allow empty selection
    @Prop(Array) public selected!: IRecipient[]
    @Prop(Array) public recipients!: IRecipient[]
    @Prop(String) public title!: string
    @Prop({ type: Boolean, default: false }) public canPickVirtualUsers!: string

    private onCancelRecipients() {
        this.$emit('close')
    }

    private onConfirmRecipients(selectedRecipients: IRecipient[]) {
        this.$emit('confirm', selectedRecipients)
    }
}
